import { useState } from "react";
import { database } from "./firebase";
import { doc, setDoc, getDoc, writeBatch, serverTimestamp } from "firebase/firestore";
import CryptoJS from "crypto-js";

function AdminUploadFiles() {
    const [file, setFile] = useState(null);
    const [jsonContentWordBase, setJsonContentWordBase] = useState([]);
    const [isLoadingSendWordsToServer, setIsLoadingSendWordsToServer] = useState(false);
    const [hashWordBase, setHashWordBase] = useState('');
    const [hashChooseWords, setHashChooseWords] = useState('');
    const [hashInputVerbType1, setHashInputVerbType1] = useState('');
    const [hashReportedSpeech, setHashReportedSpeech] = useState('');
    const [hashProvinces, setHashProvinces] = useState('');
    const [hashProvincesV2, setHashProvincesV2] = useState('');
    const [hashTextListening, setHashTextListening] = useState('');
    const [hashAudioChooseAnswer, setHashAudioChooseAnswer] = useState('');
    const [hashReferences, setHashReferences] = useState('');
    const [hashChooseOption, setHashChooseOption] = useState('');
    const [hashRecipes, setHashRecipes] = useState('');
    const [hashArticles, setHashArticles] = useState('');
    const [courseFile, setCourseFile] = useState(null);
    const [isUploadingCourse, setIsUploadingCourse] = useState(false);

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);

        if (selectedFile) {
            const fileName = selectedFile.name;
            const fileHash = await calculateFileHash(selectedFile);
            if (fileName === "ChooseWords.json") {
                setHashChooseWords(fileHash);
                // console.log(fileName)
            } else if (fileName === "InputVerbType1.json") {
                setHashInputVerbType1(fileHash);
            } else if (fileName === "TextListening.json") {
                setHashTextListening(fileHash);
            } else if (fileName === "Provinces.json") {
                setHashProvinces(fileHash);
            } else if (fileName === "AudioChooseAnswer.json") {
                setHashAudioChooseAnswer(fileHash);
            } else if (fileName === "ReportedSpeech.json") {
                setHashReportedSpeech(fileHash);
            } else if (fileName === "wordbase.json") {
                setHashWordBase(fileHash);
            } else if (fileName === "ReferenceGroups.json") {
                setHashReferences(fileHash);
            } else if (fileName === "ChooseOption.json") {
                setHashChooseOption(fileHash);
            } else if (fileName === "recipes.json") {
                setHashRecipes(fileHash);
            }else if (fileName === "Articles.json") {
                setHashArticles(fileHash);
            } else if (fileName === "Provinces_v2.json") {
                setHashProvincesV2(fileHash);
            } else {
                console.log("Another name of file")
            }
        }
    };

    const calculateFileHash = async (file) => {
        const arrayBuffer = await file.arrayBuffer(); // Конвертируем файл в ArrayBuffer
        const hashBuffer = await crypto.subtle.digest('SHA-256', arrayBuffer); // Вычисляем хэш
        const hashArray = Array.from(new Uint8Array(hashBuffer)); // Преобразуем в массив байтов
        const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join(''); // Конвертируем в HEX
        console.log("hash calculated")
        return hashHex;
    };

    const handleSubmitRecipes = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'Recipes', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "other"),
            {
                hashRecipes: hashRecipes
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitChooseOption = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'ChooseOption', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "exercises"),
            {
                hashChooseOption: hashChooseOption
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitReportedSpeech = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'ReportedSpeechTasks', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "exercises"),
            {
                hashReportedSpeech: hashReportedSpeech
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitChooseWordsFromGrid = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'ChooseWords', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "exercises"),
            {
                hashChooseWords: hashChooseWords
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitInputVerbType1 = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'InputVerbType1', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "exercises"),
            {
                hashInputVerbType1: hashInputVerbType1
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitTextListening = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'TextListening', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "exercises"),
            {
                hashTextListening: hashTextListening
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitAudioChooseAnswer = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'AudioChooseAnswer', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "exercises"),
            {
                hashAudioChooseAnswer: hashAudioChooseAnswer
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    function countWordsByCountry(wordArray) {
        const countryCount = {}; // 1. Инициализируем пустой объект для подсчёта стран.
    
        wordArray.forEach(wordEntry => { // 2. Перебираем каждый объект в массиве.
            const countries = Object.values(wordEntry.countries); // 3. Извлекаем все страны для текущего слова.
    
            countries.forEach(country => { // 4. Перебираем список стран для данного слова.
                if (countryCount[country]) { // 5. Проверяем, есть ли уже страна в объекте countryCount.
                    countryCount[country] += 1; // 6. Если есть, увеличиваем счётчик для этой страны на 1.
                } else {
                    countryCount[country] = 1; // 7. Если страны ещё нет в объекте, добавляем её со значением 1.
                }
            });
        });
    
        return countryCount; // 8. Возвращаем объект с подсчитанными странами.
    }

    // Отправка слов на сервер

    async function setUpdatesWordBase(countryCount) {
        await setDoc(doc(database, "updates", "words"), {
            count: jsonContentWordBase.length,
            date: new Date(),
            type: "words",
            hashWordBase: hashWordBase,
            ...countryCount
        })
    }

    function stripEmojis(str) {
    if (typeof str !== "string") return "";
    return str.replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|\u2011-\u26FF|\uD83E[\uDD10-\uDDFF])/g,
        ""
    ).trim();
}

function normalizeStyle(value) {
    if (typeof value !== "string") return null;

    const v = value.trim().toLowerCase();
    if (v === "formal" || v === "informal") {
        return v;
    }

    return null;
}

    async function addDocWordBase(obj) {
        setIsLoadingSendWordsToServer(true);
        await setDoc(doc(database, "Words", obj.id), {
            id: obj.id,
            wordOrPhrase: obj.wordOrPhrase,
            type: obj.type,
            style: obj.style,
            isPronominalVerb: obj.isPronominalVerb,
            engTranslation: obj.engTranslation,
            rusTranslation: obj.rusTranslation,
            topics: obj.topics,
            hasAudioArgentino: obj.hasAudioArgentino,
            gender: obj.gender,
            countries: obj.countries,
            example: obj.example,
            exampleTenses: obj.exampleTenses,
            engExample: obj.engExample,
            rusExample: obj.rusExample,
            engExplanation: obj.engExplanation,
            rusExplanation: obj.rusExplanation,
            engAnalog: obj.engAnalog,
            rusAnalog: obj.rusAnalog,
            nounGenders: obj.nounGenders,
            adjGenders: obj.adjGenders,
            isRegularVerb: obj.isRegularVerb,
            presenteDeIndicativo: obj.presenteDeIndicativo,
            preteritoPerfectoSimple: obj.preteritoPerfectoSimple,
            preteritoPerfecto: obj.preteritoPerfecto,
            preteritoImperfecto: obj.preteritoImperfecto,
            futuroDeIndicativo: obj.futuroDeIndicativo,
            imperativoAfirmativo: obj.imperativoAfirmativo,
            imperativoNegativo: obj.imperativoNegativo,
            presenteDeSubjuntivo: obj.presenteDeSubjuntivo,
            imperfectoDeSubjuntivo: obj.imperfectoDeSubjuntivo
        });
        setIsLoadingSendWordsToServer(false);
    };


    // новая функция - выгружает только изменения слов
    async function sendWordsToServer(e) {
    e.preventDefault();

    let modifiedArray = [];
    let wordsCount = jsonContentWordBase.length + 1;

    jsonContentWordBase.forEach((element) => {

        let objectInside = {};

        if (element.phrase) {
            objectInside.id = `wordID_${wordsCount}`;
            wordsCount += 1;
        } else {
            objectInside.id = element.id;
        }

        objectInside.wordOrPhrase =
            element.word || element.phrase || "ERROR!";

        objectInside.type = element.type || "";
        objectInside.style = element.style || "";

        objectInside.isPronominalVerb =
            element.reflexive === "yes";

        objectInside.isRegularVerb =
            element.verbtype === "regular";

        objectInside.engTranslation = Object.values(element.engtranslation || {});
        objectInside.rusTranslation = Object.values(element.rustranslation || {});
        objectInside.topics = Object.values(element.topics || {});

        objectInside.hasAudioArgentino =
            element.hasaudioargentino === "yes";

        objectInside.gender = element.gender || "";

        objectInside.countries = Object.values(element.country || {})
            .map(item =>
                item.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '')
            );

        objectInside.example = element.example || "";
        objectInside.exampleTenses =
            Object.values(element.example_tenses || {});

        objectInside.engExample = element.example_eng || "";
        objectInside.rusExample = element.example_rus || "";
        objectInside.engExplanation = element.explanation_eng || "";
        objectInside.rusExplanation = element.explanation_rus || "";
        objectInside.engAnalog = element.eng_analog || "";
        objectInside.rusAnalog = element.rus_analog || "";
        objectInside.mnemonics = element.mnemonics || {};

        objectInside.nounGenders = element.noungenders || {};
        objectInside.adjGenders = element.adjgenders || {};

        objectInside.presenteDeIndicativo = element.presenteDeIndicativo || {};
        objectInside.preteritoPerfectoSimple = element.preterito || {};
        objectInside.preteritoPerfecto = element.preteritoPerfecto || {};
        objectInside.preteritoImperfecto = element.imperfectodeIndicativo || {};
        objectInside.futuroDeIndicativo = element.futurodeIndicativo || {};
        objectInside.imperativoAfirmativo = element.imperativoAfirmativo || {};
        objectInside.imperativoNegativo = element.imperativoNegativo || {};
        objectInside.presenteDeSubjuntivo = element.presenteDeSubjuntivo || {};
        objectInside.imperfectoDeSubjuntivo = element.imperfectoDeSubjuntivo || {};

        modifiedArray.push(objectInside);
    });

    // 👇 ВАЖНО — вызываем один раз
    await uploadWords(modifiedArray);

    const result = countWordsByCountry(modifiedArray);
    setUpdatesWordBase(result);
}

    const onChangeFileWordBase = async (e) => {
        if (e.target.files && e.target.files[0]) {
        //   const updatedJSON = e.target.files[0];
        //   console.log(updatedJSON);
            const fileReader = new FileReader();
            fileReader.readAsText(e.target.files[0], "UTF-8");
            fileReader.onload = e => {
            // console.log("e.target.result", e.target);
            const target = e.target;
            const result = target?.result;
            var myObject = JSON.parse(result);
            var array = [];
            for (var key in myObject) {
                var item = myObject[key];
                array.push(item);
            }
            setJsonContentWordBase(array);
        }
    }};

    const handleSubmitProvincesInfo = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'ProvincesInfo', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "other"),
            {
                hashProvinces: hashProvinces
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitReferenceGroups = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'ReferenceGroups', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
        await setDoc(
            doc(database, "updates", "other"),
            {
                hashReferences: hashReferences
            },
            { merge: true } // Указываем, что нужно обновить только изменённые поля
        );
    };

    const handleSubmitReferenceWordToGroupMap = async (event) => {
        event.preventDefault();
    
        if (file) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);
            
            // Пример отправки данных в Firestore
            jsonData.forEach(async (item, index) => {
              const docRef = doc(database, 'ReferenceWordToGroupMap', item.id);
              await setDoc(docRef, item);
            });
    
            alert('Файл успешно загружен и данные отправлены в Firestore');
          };
    
          reader.readAsText(file);
        }
    };

    function safeString(value) {
    return typeof value === "string" && value.trim() !== ""
        ? value
        : null;
    }

    function mapOldWordToNewSchema(old) {
        
        const wordBase = {
        id: old.id,

        wordOrPhrase: safeString(
            old.wordOrPhrase ??
            old.word ??
            old.phrase
        ),

        type: safeString(old.type) ?? "unknown",
        style: normalizeStyle(old.style),
        isRegularVerb: normalizeRegularVerb(old),
        hasAudioArgentino:
    typeof old.hasaudioargentino === "string" &&
    old.hasaudioargentino.trim().toLowerCase() === "yes",

        gender: safeString(old.gender),
        topics: normalizeTopics(old.topics),
        engTranslation: normalizeTranslationArray(old.engtranslation),
        rusTranslation: normalizeTranslationArray(old.rustranslation),
        
        countries:
    old.country && typeof old.country === "object"
        ? Object.values(old.country)
            .map(stripEmojis)
            .filter(Boolean)
        : []
        };

        const nounGenders = normalizeNounGenders(
            old.noungenders,
            old.id
        );

        const adjGenders = normalizeAdjGenders(
            old.adjgenders,
            old.id
        );

    const verbForms = [];

    function mapVerbForms(obj, tense) {
        if (!obj || typeof obj !== "object") return;
        Object.entries(obj).forEach(([person, value]) => {
            verbForms.push({
                id: `${old.id}_${tense}_${person}`,
                wordID: old.id,
                tense,
                person,
                value
            });
        });
    }

    mapVerbForms(old.presenteDeIndicativo, "presente");
    mapVerbForms(old.preterito, "preteritoPerfectoSimple");
    mapVerbForms(old.preteritoPerfecto, "preteritoPerfecto");
    mapVerbForms(old.imperfectodeIndicativo, "preteritoImperfecto");
    mapVerbForms(old.futurodeIndicativo, "futuro");
    mapVerbForms(old.imperativoAfirmativo, "imperativoAfirmativo");
    mapVerbForms(old.imperativoNegativo, "imperativoNegativo");
    mapVerbForms(old.presenteDeSubjuntivo, "presenteSubjuntivo");
    mapVerbForms(old.imperfectoDeSubjuntivo, "imperfectoSubjuntivo");

    const examples = [];

    if (old.example) {
        examples.push({
            id: `${old.id}_example_es`,
            wordID: old.id,
            language: "es",
            text: old.example,
            tense: old.exampleTenses?.[0] || null
        });
    }

    if (old.engExample) {
        examples.push({
            id: `${old.id}_example_en`,
            wordID: old.id,
            language: "en",
            text: old.engExample
        });
    }

    if (old.rusExample) {
        examples.push({
            id: `${old.id}_example_ru`,
            wordID: old.id,
            language: "ru",
            text: old.rusExample
        });
    }

    const explanations = [];

    if (old.engExplanation) {
        explanations.push({
            id: `${old.id}_explanation_en`,
            wordID: old.id,
            language: "en",
            explanation: old.engExplanation,
            analog: old.engAnalog || null
        });
    }

    if (old.rusExplanation) {
        explanations.push({
            id: `${old.id}_explanation_ru`,
            wordID: old.id,
            language: "ru",
            explanation: old.rusExplanation,
            analog: old.rusAnalog || null
        });
    }

    const mnemonics = [];

    if (old.mnemonics?.en) {
        mnemonics.push({
            id: `${old.id}_mnemonic_en`,
            wordID: old.id,
            language: "en",
            text: old.mnemonics.en
        });
    }

    if (old.mnemonics?.ru) {
        mnemonics.push({
            id: `${old.id}_mnemonic_ru`,
            wordID: old.id,
            language: "ru",
            text: old.mnemonics.ru
        });
    }
    

    return {
        wordBase,
        verbForms,
        examples,
        explanations,
        nounGenders,
        adjGenders,
        mnemonics
    };
}

    function normalizeNounGenders(value, wordID) {
        if (!value || typeof value !== "object") {
            return [];
        }

        return Object.entries(value)
            .filter(([form, text]) =>
                typeof form === "string" &&
                typeof text === "string" &&
                form.trim() &&
                text.trim()
            )
            .map(([form, text]) => ({
                id: `${wordID}_noun_${form}`,
                wordID,
                form: form.trim(),
                value: text.trim()
            }));
        }

        function normalizeAdjGenders(value, wordID) {
    if (!value || typeof value !== "object") {
        return [];
    }

    return Object.entries(value)
        .filter(([form, text]) =>
            typeof form === "string" &&
            typeof text === "string" &&
            form.trim() &&
            text.trim()
        )
        .map(([form, text]) => ({
            id: `${wordID}_adj_${form}`,
            wordID,
            form: form.trim(),
            value: text.trim()
        }));
}

function normalizeTranslationArray(value) {
    if (!value || typeof value !== "object") {
        return [];
    }

    return Object.values(value)
        .filter(v => typeof v === "string")
        .map(v => v.trim())
        .filter(Boolean);
}

function normalizeTopics(value) {
    if (!value || typeof value !== "object") {
        return [];
    }

    return Object.values(value)
        .filter(v => typeof v === "string")
        .map(v => v.trim())
        .filter(Boolean);
}

function normalizeRegularVerb(old) {

    // Если это не глагол — возвращаем null
    if (old.type !== "verb") {
        return null;
    }

    if (typeof old.verbtype !== "string") {
        return null;
    }

    const value = old.verbtype.trim().toLowerCase();

    if (value === "regular") return true;
    if (value === "irregular") return false;

    return null;
}

// async function sendWordsToServerV2(e) {
//   e.preventDefault();

//   setIsLoadingSendWordsToServer(true);

//   for (const oldWord of jsonContentWordBase) {
//     const mapped = mapOldWordToNewSchema(oldWord);

//     // WordBase
//     await setDoc(
//       doc(database, "WordBase_v2", mapped.wordBase.id),
//       mapped.wordBase,
//     );

//     // Translations
//     for (const t of mapped.translations) {
//       await setDoc(doc(database, "WordTranslations_v2", t.id), t);
//     }

//     // Verb Forms
//     for (const vf of mapped.verbForms) {
//       await setDoc(doc(database, "VerbForms_v2", vf.id), vf);
//     }

//     // Examples
//     for (const ex of mapped.examples) {
//       await setDoc(doc(database, "WordExamples_v2", ex.id), ex);
//     }

//     // Explanations
//     for (const exp of mapped.explanations) {
//       await setDoc(doc(database, "WordExplanations_v2", exp.id), exp);
//     }
//   }

//   alert("Слова успешно загружены в Firestore (новая схема v2)");
//   setIsLoadingSendWordsToServer(false);
// }

function generateWordBaseV2File(e) {
  e.preventDefault();

  const words = [];
  const verbForms = [];
  const examples = [];
  const explanations = [];
  const nounGenders = [];
  const adjGenders = [];
  const mnemonics = [];

  jsonContentWordBase.forEach((oldWord) => {
    const mapped = mapOldWordToNewSchema(oldWord);

    if (!mapped.wordBase.wordOrPhrase) {
      console.warn("Skipped word without wordOrPhrase:", oldWord.id);
      return;
    }

    words.push(mapped.wordBase);
    verbForms.push(...mapped.verbForms);
    examples.push(...mapped.examples);
    explanations.push(...mapped.explanations);
    nounGenders.push(...mapped.nounGenders);
    adjGenders.push(...mapped.adjGenders);
    mnemonics.push(...mapped.mnemonics);
  });

  const result = {
    meta: {
      version: "v2",
      generatedAt: new Date().toISOString(),
      wordsCount: words.length,
    },
    words,
    verbForms,
    examples,
    explanations,
    nounGenders,
    adjGenders,
    mnemonics
  };

  const jsonString = JSON.stringify(result, null, 2);
  const blob = new Blob([jsonString], { type: "application/json" });
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = "wordbase_v2_cloudkit.json";
  link.click();

  URL.revokeObjectURL(url);
}

// создание hash
function stableStringify(obj) {
    if (obj !== null && typeof obj === "object") {
        if (Array.isArray(obj)) {
            return `[${obj.map(stableStringify).join(",")}]`;
        }

        return `{${Object.keys(obj)
            .sort()
            .map(key => `"${key}":${stableStringify(obj[key])}`)
            .join(",")}}`;
    }
    return JSON.stringify(obj);
}

function generateHash(obj) {
    const stable = stableStringify(obj);
    return CryptoJS.SHA256(stable).toString();
}

// выгрузка слов вместе с hash и TimeStamp
async function uploadWords(wordsArray) {
    setIsLoadingSendWordsToServer(true);
    const hashDocRef = doc(database, "metadata", "wordHashes");
    const hashSnapshot = await getDoc(hashDocRef);

    const existingHashes = hashSnapshot.exists()
        ? hashSnapshot.data()
        : {};

    let batch = writeBatch(database);
    let operationCount = 0;
    const BATCH_LIMIT = 450; // лучше меньше 500 для запаса

    let updatedHashes = { ...existingHashes };
    let hasChanges = false;

    for (const word of wordsArray) {

        const wordCopy = { ...word };
        delete wordCopy.lastUpdated;

        const newHash = generateHash(wordCopy);
        const existingHash = existingHashes[word.id];

        if (newHash !== existingHash) {

            const wordRef = doc(database, "Words_v2", word.id);

            batch.set(wordRef, {
                ...wordCopy,
                lastUpdated: serverTimestamp()
            });

            updatedHashes[word.id] = newHash;
            hasChanges = true;

            operationCount++;

            // 🔥 если достигли лимита — commit
            if (operationCount >= BATCH_LIMIT) {
                await batch.commit();
                batch = writeBatch(database);
                operationCount = 0;
            }
        }
    }

    // обновляем metadata
    if (hasChanges) {

        batch.set(hashDocRef, {
            ...updatedHashes,
            lastUpdatedGlobal: serverTimestamp()
        });

        await batch.commit();
    }

    console.log("✅ Upload completed");
    setIsLoadingSendWordsToServer(false);
}

// выгрузка Статей
const handleSubmitArticles = async (event) => {
    event.preventDefault();

    if (file) {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);

            for (const item of jsonData) {
                const docRef = doc(database, 'Articles', item.id);

                await setDoc(docRef, {
                    ...item,
                    updatedAt: item.updatedAt
                        ? new Date(item.updatedAt)
                        : serverTimestamp()
                });
            }

            alert('Articles успешно загружены в Firestore');
        };

        reader.readAsText(file);
    }

    // если используешь систему обновлений
    await setDoc(
        doc(database, "updates", "other"),
        {
            hashArticles: hashArticles
        },
        { merge: true }
    );
};

// выгрузка тестовых Статей
const handleSubmitTestArticles = async (event) => {
    event.preventDefault();

    if (file) {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);

            for (const item of jsonData) {
                const docRef = doc(database, 'TestArticles', item.id);

                await setDoc(docRef, {
                    ...item,
                    updatedAt: item.updatedAt
                        ? new Date(item.updatedAt)
                        : serverTimestamp()
                });
            }

            alert('Тестовые Статьи успешно загружены в Firestore');
        };

        reader.readAsText(file);
    }
};

// добавление учителей
const handleSubmitTeachers = async (event) => {
    event.preventDefault();

    if (file) {
        const reader = new FileReader();

        reader.onload = async (e) => {
            const jsonData = JSON.parse(e.target.result);

            // 1. СНАЧАЛА загружаем учителей
            for (const item of jsonData) {
                const docRef = doc(database, 'Teachers', item.id);

                await setDoc(docRef, {
                    ...item,
                    updatedAt: serverTimestamp()
                });
            }

            // 2. ГРУППИРУЕМ по странам
            const grouped = groupByCountry(jsonData);

            // 3. СЧИТАЕМ hash по каждой стране
            const countryHashes = {};

            for (const country in grouped) {
                // сортировка, чтобы без изменений не генерировал новый hash
                grouped[country].sort((a, b) => a.id.localeCompare(b.id));
                countryHashes[country] = generateHash(grouped[country]);
            }

            // 4. СОХРАНЯЕМ в updates
            await setDoc(
                doc(database, "updates", "teachers"),
                countryHashes,
                { merge: true }
            );

            alert('Teachers успешно загружены в Firestore');
        };

        reader.readAsText(file);
    }
};

// создаем hash по странам учителей
function groupByCountry(data) {
    const result = {};

    data.forEach(item => {
        const country = item.country || "unknown";

        if (!result[country]) {
            result[country] = [];
        }

        result[country].push(item);
    });

    return result;
}

// выгрузка ProvincesInfo v2
const handleSubmitProvincesInfoV2 = async (event) => {
    event.preventDefault();

    if (!file) {
        alert("Сначала выберите Provinces_v2.json");
        return;
    }

    try {
        const jsonData = JSON.parse(await file.text());

        if (!Array.isArray(jsonData)) {
            throw new Error("JSON должен содержать массив провинций");
        }

        const batchSize = 450; // Firestore допускает максимум 500 операций в batch

        for (let start = 0; start < jsonData.length; start += batchSize) {
            const batch = writeBatch(database);
            const provinces = jsonData.slice(start, start + batchSize);

            provinces.forEach((item) => {
                const documentId =
                    typeof item.id === "string" && item.id.trim()
                        ? item.id.trim()
                        : `${item.country}_${item.province}`;

                batch.set(
                    doc(database, "ProvincesInfo_v2", documentId),
                    item
                );
            });

            await batch.commit();
        }
        await setDoc(
            doc(database, "updates", "other"),
            {
                hashProvincesV2Arg: hashProvincesV2,
            },
            { merge: true }
        );

        alert(`Загружено в ProvincesInfo_v2: ${jsonData.length}`);
    } catch (error) {
        console.error("Ошибка загрузки ProvincesInfo_v2:", error);
        alert(`Ошибка загрузки: ${error.message}`);
    }
};

const handleSubmitCourse = async (event) => {
    event.preventDefault();

    if (!courseFile || isUploadingCourse) return;

    setIsUploadingCourse(true);

    try {
        const text = await courseFile.text();
        const course = JSON.parse(text.replace(/^\uFEFF/, ""));

        if (!course || typeof course !== "object" || Array.isArray(course)) {
            throw new Error("JSON должен содержать один объект урока.");
        }

        if (
            typeof course.id !== "string" ||
            !course.id.trim() ||
            course.id.includes("/") ||
            course.id === "." ||
            course.id === ".."
        ) {
            throw new Error("В JSON отсутствует корректный id урока.");
        }

        if (!Array.isArray(course.blocks)) {
            throw new Error("Поле blocks должно быть массивом.");
        }

        await setDoc(
            doc(database, "Courses", course.id),
            course
        );

        alert(`Урок успешно загружен в Courses/${course.id}`);
    } catch (error) {
        console.error("Ошибка загрузки курса:", error);
        alert(`Не удалось загрузить курс: ${error.message}`);
    } finally {
        setIsUploadingCourse(false);
    }
};


    return (
        <div className="w-full mt-24 overflow-y-auto">
            {/* <div className="grid grid-cols-[2fr_1fr] divide-x-2"> */}
                <div className="flex items-center flex-col">
                    <h1 className="text-4xl">Firebase</h1>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">База слов</h1>
                        <div className='text-left pb-1'>
                            Кол-во слов: {jsonContentWordBase.length !== 0 ? <span>{jsonContentWordBase.length}</span> : "Загрузите файл"}
                        </div>
                        <form className="flex flex-col space-y-2">
                        <input type="file" accept=".json" onChange={onChangeFileWordBase} />
                            <button onClick={sendWordsToServer} className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">{isLoadingSendWordsToServer ? "Загрузка ..." : "Отправить в Firestore v2"}</button>
                            {/* <button
                                onClick={sendWordsToServerV2}
                                className="bg-white p-2 rounded-lg hover:bg-blue-500"
                                type="submit"
                            >
                                {isLoadingSendWordsToServer
                                    ? "Загрузка v2..."
                                    : "Отправить в Firestore (НОВАЯ СХЕМА)"}
                            </button> */}
                            {/* <button
                                onClick={generateWordBaseV2File}
                                className="bg-white p-2 rounded-lg hover:bg-purple-500"
                                type="button"
                            >
                                📦 Скачать файл (CloudKit / v2)
                            </button> */}
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">ChooseWords</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitChooseWordsFromGrid}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">InputVerbType1</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitInputVerbType1}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">TextListening</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitTextListening}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">AudioChooseAnswer</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitAudioChooseAnswer}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">ReportedSpeech</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitReportedSpeech}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    {/* <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">Provinces Info</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitProvincesInfo}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div> */}
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">Provinces Info</h1>

                        <form className="flex flex-col space-y-2 mb-4" onSubmit={handleSubmitProvincesInfo}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">
                                Загрузить старый вариант
                            </button>
                        </form>

                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitProvincesInfoV2}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-blue-500" type="submit">
                                Загрузить Provinces v2 Argentina
                            </button>
                        </form>
                    </div>
                    <div className="flex flex-row justify-around">
                        <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                            <h1 className="text-center text-xl pb-2 font-bold">Reference Groups</h1>
                            <form className="flex flex-col space-y-2" onSubmit={handleSubmitReferenceGroups}>
                                <input type="file" accept=".json" onChange={handleFileChange} />
                                <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                            </form>
                        </div>
                        <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                            <h1 className="text-center text-xl pb-2 font-bold">Reference Word To Group Map</h1>
                            <form className="flex flex-col space-y-2" onSubmit={handleSubmitReferenceWordToGroupMap}>
                                <input type="file" accept=".json" onChange={handleFileChange} />
                                <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                            </form>
                        </div>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">ChooseOption</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitChooseOption}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">Recipes</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitRecipes}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">Отправить в Firestore</button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">Articles</h1>

                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitArticles}>
                            <input type="file" accept=".json" onChange={handleFileChange} />

                            <button
                                className="bg-white p-2 rounded-lg hover:bg-green-500"
                                type="submit"
                            >
                                Отправить в Firestore
                            </button>

                            <button
                                type="button"
                                onClick={handleSubmitTestArticles}
                                className="bg-white p-2 rounded-lg hover:bg-blue-500"
                            >
                                Отправить Test Articles
                            </button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">Teachers</h1>
                        <form className="flex flex-col space-y-2" onSubmit={handleSubmitTeachers}>
                            <input type="file" accept=".json" onChange={handleFileChange} />
                            <button className="bg-white p-2 rounded-lg hover:bg-green-500" type="submit">
                                Отправить в Firestore
                            </button>
                        </form>
                    </div>
                    <div className="m-4 bg-white bg-opacity-50 p-4 rounded-lg w-3/4">
                        <h1 className="text-center text-xl pb-2 font-bold">
                            Courses
                        </h1>

                        <form
                            className="flex flex-col space-y-2"
                            onSubmit={handleSubmitCourse}
                        >
                            <input
                                type="file"
                                accept=".json,application/json"
                                disabled={isUploadingCourse}
                                onChange={(event) => {
                                    setCourseFile(event.target.files?.[0] ?? null);
                                }}
                            />

                            <button
                                type="submit"
                                disabled={!courseFile || isUploadingCourse}
                                className="bg-white p-2 rounded-lg hover:bg-green-500 disabled:opacity-50 disabled:cursor-not-allowed"
                            >
                                {isUploadingCourse
                                    ? "Загрузка..."
                                    : "Отправить в Courses"}
                            </button>
                        </form>
                    </div>
                </div>
                {/* <div className="flex justify-center">
                    <h1 className="text-4xl">Apple CloudKit</h1>
                </div> */}
            {/* </div> */}
        </div>
    )
}

export default AdminUploadFiles